import { TableRow, TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutFAKProfileList } from "./autogen/AutogenLayoutFAKProfileList";

export class FAKProfileList extends AutogenLayoutFAKProfileList {

    override onLoad() {
        this.mainDataSource.search();
    }

}
